'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _translate = _interopRequireDefault(require("./../translate"));

var _hawaComponents = require("hawa-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SelectionView = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectionView, _React$Component);

  function SelectionView(props) {
    _classCallCheck(this, SelectionView);

    return _possibleConstructorReturn(this, (SelectionView.__proto__ || Object.getPrototypeOf(SelectionView)).call(this, props));
  }

  _createClass(SelectionView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          resetButton = _this$props.resetButton;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x relative-grid'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9"
      }, resetButton, /*#__PURE__*/_react.default.createElement("h1", null, t('Planning tool Hawa Banio')))), this.props.productTypes.length > 0 && /*#__PURE__*/_react.default.createElement(_hawaComponents.ProductTypeSelector, {
        productTypes: this.props.productTypes,
        texts: {
          pleaseChoose: t('Please choose')
        },
        classNames: 'small-up-1 medium-up-2 large-up-4',
        save: this.props.save
      }), /*#__PURE__*/_react.default.createElement("p", null, t('For illustration purposes, here is the result of an')), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_hawaComponents.LargeButton, {
        isLink: true,
        href: "/static/assets/beispiel-konfiguration.pdf",
        text: t('example configuration')
      })));
    }
  }]);

  return SelectionView;
}(_react.default.Component);

SelectionView.propTypes = {
  t: PropTypes.func.isRequired,
  productTypes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string.isRequired)),
  save: PropTypes.func.isRequired,
  resetButton: PropTypes.object
};

var _default = (0, _translate.default)(SelectionView);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/selection-view/index.js
// module id = 549
// module chunks = 0